import { Select, Spin } from "antd";
import { TError, TOption } from "../../types/common";

type SelectInputType = {
  onChange?(value: number, option: TOption | TOption[]): void;
  label?: string;
  value: number | string | null;
  name: string;
  options: TOption[];
  error?: TError;
  multiple?: "multiple" | "tags";
  disabled?: boolean;
  required?: boolean;
  loading?: boolean;
  acceptNewItems?: boolean;
  setNotFoundOption?: (value: boolean) => void;
  placeholder?: string | React.ReactNode;
  getPopupContainer?: (trigger: HTMLElement) => HTMLElement;
  onSearch?: (value: string) => void;
};

const SelectInput = (props: SelectInputType) => {
  const {
    onChange,
    value,
    options,
    multiple,
    disabled,
    loading = false,
    setNotFoundOption = () => {},
    acceptNewItems = false,
    placeholder = "",
    onSearch,
    ...rest
  } = props;

  const handleSearch = (newValue: string) => {
    if (acceptNewItems) {
      const isSearchValueInState = options.some(
        (option) => option.value === newValue,
      );
      if (!isSearchValueInState || newValue === "") {
        setNotFoundOption(true);
      } else {
        setNotFoundOption(false);
      }
    }
    onSearch?.(newValue);
  };

  return (
    <Select
      showSearch
      allowClear
      optionFilterProp="children"
      onChange={onChange}
      value={value as any}
      filterOption={
        onSearch
          ? false
          : (input, option) =>
              String(option?.label ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
      }
      style={{
        display: "block",
        width: "100%",
      }}
      options={options}
      mode={multiple && "multiple"}
      disabled={disabled}
      size="middle"
      loading={loading}
      onSearch={handleSearch}
      notFoundContent={loading ? <Spin size="small" /> : undefined}
      placeholder={placeholder}
      {...rest}
    />
  );
};

export default SelectInput;
